<template>
    <v-tab-item :value="COMPANY.value">
        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- 에프원시큐리티는 <br>
                    정보보안전문<br class="d-block d-sm-none">서비스기업입니다. -->
                    {{ settings.about }}
                </h3>
                <h4 class="line-txt txt-40 font-weight-700 mb-8 mb-lg-16">
                    핵심사업분야
                </h4>
                <p class="page-text-lg color-grey-57 mb-28 mb-lg-46">정보보호 인증컨설팅</p>
                <div class="mb-40 mb-md-50 mb-lg-70">
                    <v-row class="mb-40 mb-lg-86">
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-1.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">정보통신기반시설 취약점진단</p>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-2.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">모의해킹</p>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-3.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">ISMS-P</p>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-4.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">ISMS</p>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-5.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">PIMS</p>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="4">
                            <div class="radius-sm card pa-16 py-md-68 h-100">
                                <v-img class="mx-auto mb-12 mb-lg-16 d-block" max-width="85" src="/images/sub/about/company/s1-icon1-6.png"></v-img>
                                <p class="page-text-lg font-weight-bold text-center">ISO27001</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <h4 class="line-txt txt-40 font-weight-700 mb-8 mb-lg-16">
                    정보보호 솔루션
                </h4>
                <p class="page-text-lg color-grey-57 mb-28 mb-lg-46">
                    컨설팅을 기반으로 중소기업 정보보안의 수행경험 및 현안에 대한 <br class="d-none d-lg-block">
                    고충을 반영하여 정보보호 솔루션을 개발하여 서비스를 제공합니다.
                </p>
                <div class="radius bg-img card" style="background-image: url(/images/sub/about/company/bg.png);">
                    <v-row no-gutters class="line-item-group">
                        <v-col cols="12" md="4" class="line-item pa-16 py-lg-96">
                            <v-img class="mx-auto mb-14 mb-lg-14 d-block" max-width="60" src="/images/sub/about/company/s1-icon2-1.png"></v-img>
                            <h5 class="font-size-18 font-size-lg-28 line-height-12 text-center color-white">
                                웹방화벽
                            </h5>
                        </v-col>
                        <v-col cols="12" md="4" class="line-item pa-16 py-lg-96">
                            <v-img class="mx-auto mb-14 mb-lg-14 d-block" max-width="60" src="/images/sub/about/company/s1-icon2-2.png"></v-img>
                            <h5 class="font-size-18 font-size-lg-28 line-height-12 text-center color-white">
                                웹쉘탐지
                            </h5>
                        </v-col>
                        <v-col cols="12" md="4" class="line-item pa-16 py-lg-96">
                            <v-img class="mx-auto mb-14 mb-lg-14 d-block" max-width="58" src="/images/sub/about/company/s1-icon2-3.png"></v-img>
                            <h5 class="font-size-18 font-size-lg-28 line-height-12 text-center color-white">
                                웹악성코드 분석탐지등
                            </h5>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { ABOUT_US_TABS } from "@/assets/variables";
const { COMPANY } = ABOUT_US_TABS;
import api from "@/api"
export default {
    data() {
        return {
            COMPANY,
            filter: {
                code: "ko"
            },
            settings: null
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style scoped>

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .line-item{
        position: relative;
    }
    .line-item-group .line-item:not(:last-child)::after{
        content: "";
        display: block;
        position: absolute;
        width: 1px;
        height: 80px;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-color: rgba(255, 255, 255, 0.3);
    }
}
@media (min-width:1200px){
}

</style>
